module.exports = __webpack_public_path__ + "assets/img/3_1159_big.fe204f91.jpg";